<div class="global-case-type">
  <payee-form-field
    width="wide"
    [aiFilled]="isAiFilled(globalCaseType)"
  >
    <span payee-label>Ügy típusa minden követeléshez</span>
    <div class="radio-group">
      <label>
        <input
          type="radio"
          [formControl]="globalCaseType"
          [value]="CASE_TYPE.INVOICE"
        />
        Számla alapú ügy
      </label>
      <label>
        <input
          type="radio"
          [formControl]="globalCaseType"
          [value]="CASE_TYPE.CONTRACT"
        />
        Szerződés alapú ügy
      </label>
      <label>
        <input
          type="radio"
          [formControl]="globalCaseType"
          [value]="CASE_TYPE.CONDOMINIUM"
        />
        Társasházi egyenlegközlő alapú ügy
      </label>
    </div>
  </payee-form-field>

  @if (globalCaseType.value === CASE_TYPE.CONTRACT) {
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="globalContractIdentification"
      />
      <span payee-label>A követelés beazonosításához szükséges adatok</span>
    </payee-form-field>
    <payee-form-field width="wide">
      <payee-datepicker
        [formControl]="globalContractDate"
        [max]="max"
      ></payee-datepicker>
      <span payee-label>Szerződés kelte</span>
    </payee-form-field>
  }
</div>

<div class="global-claim-type">
  <div class="flex">
    <div class="grow1">
      <payee-form-field width="wide">
        <span payee-label>Követelés típusa minden követeléshez</span>
        <payee-autocomplete
          [options]="claimTypeOptions"
          [formControl]="globalClaimType"
          [displayWith]="claimTypeDisplayedWith"
        ></payee-autocomplete>
      </payee-form-field>
    </div>
    <button
      payee-button
      width="short"
      (click)="applyGlobalClaimType()"
    >
      Alkalmaz
    </button>
  </div>

  @if (showGlobalClaimTypeSpecification()) {
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="globalClaimTypeSpecification"
      />
      <span payee-label>Követelés típus részletezés minden követeléshez</span>
    </payee-form-field>
  }
</div>

<div class="global-interest-type">
  <payee-form-field width="wide">
    <span payee-label>Kamat típusa minden követeléshez</span>
    <payee-radio-group
      [value]="interest_type.value"
      (change)="applyGlobalInterestType($event.value)"
    ></payee-radio-group>
  </payee-form-field>

  @if (interest_type.value === INTEREST_TYPE.CONTRACTUAL) {
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="globalInterestRate"
      />
      <span payee-label>Kamat ráta minden követeléshez (%)</span>
    </payee-form-field>
  }
</div>

@if (loading()) {
  <mat-progress-spinner
    mode="indeterminate"
    diameter="40"
    style="margin: auto"
  ></mat-progress-spinner>
}

@if (!loading()) {
  @for (claimForm of claims.controls; track claimForm; let i = $index) {
    <app-claim-form
      [form]="$any(claimForm)"
      [index]="i"
      [claimTypes]="claimTypes"
      [currencyOptions]="currencyOptions"
      [globalCaseType]="globalCaseType"
      [szamlazzhuInvoices]="szamlazzhuInvoices"
    ></app-claim-form>
  }
  <div class="flex vcenter top-margin-15">
    <button
      payee-button
      (click)="addClaim()"
    >
      Követelés hozzáadása
    </button>
  </div>
}
